(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4006],{

/***/ 67809:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr",
      function () {
        return __webpack_require__(49680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ csr; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 26 modules
var layout = __webpack_require__(26419);
;// CONCATENATED MODULE: ./src/assets/images/CSR-Banner-min1.jpg
/* harmony default export */ var CSR_Banner_min1 = ({"src":"/_next/static/media/CSR-Banner-min1.1d2a31f2.jpg","height":923,"width":2313,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAbEAACAwEBAQAAAAAAAAAAAAABAgADBBEFof/EABUBAQEAAAAAAAAAAAAAAAAAAAIE/8QAHREAAQIHAAAAAAAAAAAAAAAAAQACAwQRITFRwf/aAAwDAQACEQMRAD8ArvzUVeZourqRbCUUsBw8Ibo+CIiTS12mu+BOPkL/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/health_1.jpg
/* harmony default export */ var health_1 = ({"src":"/_next/static/media/health_1.7469045a.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAACAgICAwAAAAAAAAAAAAABAgADBBEFBhIxgf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAaEQABBQEAAAAAAAAAAAAAAAABAAIDERIi/9oADAMBAAIRAxEAPwCtHbeUqwK8epqg5VrC7J5A6PrX2IiGUZdQSi6bZX//2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/health_2.jpg
/* harmony default export */ var health_2 = ({"src":"/_next/static/media/health_2.78c059ec.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBDEGIZH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIRAxEAPwCWnkmZTXUgVSbshAxJOu9eRERXIOEKm//Z"});
;// CONCATENATED MODULE: ./src/assets/images/health_3.jpg
/* harmony default export */ var health_3 = ({"src":"/_next/static/media/health_3.c8b460e3.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAACAgEFAAAAAAAAAAAAAAABAgAFEgMRITJx/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAAMBAQAAAAAAAAAAAAAAAAABAiED/9oADAMBAAIRAxEAPwCCvvdZEBVDmjZh2fcjnr4IiI8c5a1AXdJ4f//Z"});
;// CONCATENATED MODULE: ./src/assets/images/health_4.jpg
/* harmony default export */ var health_4 = ({"src":"/_next/static/media/health_4.95ecf0a7.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAaEAACAwEBAAAAAAAAAAAAAAABBAACAyFC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAaEQACAgMAAAAAAAAAAAAAAAAAAQIDESEx/9oADAMBAAIRAxEAPwCurjKKK1sr0IaYzGgtTyeECIiT1vK2OXT/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/health_5.jpg
/* harmony default export */ var health_5 = ({"src":"/_next/static/media/health_5.a7126038.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAAAAQIDEgUhFDEy/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAXEQEAAwAAAAAAAAAAAAAAAAABAAIR/9oADAMBAAIRAxEAPwC6fOyMc6Hjx+L2TS9poAEtbORobP/Z"});
;// CONCATENATED MODULE: ./src/assets/images/health_6.jpg
/* harmony default export */ var health_6 = ({"src":"/_next/static/media/health_6.d49527c2.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDBAUGIRH/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AKzNqsZG7fx8leNkcNgsaQenwHpRERYH/9k="});
;// CONCATENATED MODULE: ./src/assets/images/health_7.jpg
/* harmony default export */ var health_7 = ({"src":"/_next/static/media/health_7.87cb878d.jpg","height":380,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAgEAABAwIHAAAAAAAAAAAAAAABAAMEAgUGERIhMkFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAWEQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhEDEQA/AJ3jGUu2TJcdmMzpBoGZ5bkd+IiKdhBv/9k="});
;// CONCATENATED MODULE: ./src/assets/images/edu_1.jpg
/* harmony default export */ var edu_1 = ({"src":"/_next/static/media/edu_1.290c627f.jpg","height":750,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAACAgIDAQAAAAAAAAAAAAABAgARBCEDBhIx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAWEQEBAQAAAAAAAAAAAAAAAAAAARL/2gAMAwEAAhEDEQA/AK4XdXy8t051xEZE9MosfTqjRvQN7iIjMU//2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/edu_2.jpg
/* harmony default export */ var edu_2 = ({"src":"/_next/static/media/edu_2.7c5d181e.jpg","height":750,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABAwQDAAAAAAAAAAAAAAABAAIDBAUGEiExQf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERAv/aAAwDAQACEQMRAD8AtGb1d12gtdE6eeM7vMkoDQwk68eHpERCzVS9OOH/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/edu_3.jpg
/* harmony default export */ var edu_3 = ({"src":"/_next/static/media/edu_3.3b074684.jpg","height":750,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAABAwMFAAAAAAAAAAAAAAACAAEEAxESByIxQZH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAES/9oADAMBAAIRAxEAPwCktR2MwCMJRqwDjIy2ORNZuGvbv1ERA8x//9k="});
;// CONCATENATED MODULE: ./src/assets/images/edu_4.jpg
/* harmony default export */ var edu_4 = ({"src":"/_next/static/media/edu_4.e080659e.jpg","height":750,"width":570,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAACAQIHAAAAAAAAAAAAAAABAwACBAUHESExMoH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABcRAQADAAAAAAAAAAAAAAAAAAABERL/2gAMAwEAAhEDEQA/ALLvMV1u4pfhNNy/tUFAg0g8ancHyIiRmDb/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/kishalya1.jpg
/* harmony default export */ var kishalya1 = ({"src":"/_next/static/media/kishalya1.668bd4c0.jpg","height":395,"width":424,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAfEAABAwMFAAAAAAAAAAAAAAABAAIFBBIUAyExgbH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECAxEhIv/aAAwDAQACEQMRAD8ApTy8XrRrccVOSW7AOtaLSR71wiIiWvodS0o7WT//2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/kishalya3.jpg
/* harmony default export */ var kishalya3 = ({"src":"/_next/static/media/kishalya3.23c4ce1b.jpg","height":395,"width":424,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAAABgEFAAAAAAAAAAAAAAAAAQIDBBIRBiExQWH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABoRAAICAwAAAAAAAAAAAAAAAAABAhESIVH/2gAMAwEAAhEDEQA/AKS1EUSUylxySpNd0uVURWPvHOPAABLjHgrVvZ//2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/greenflame1.jpg
/* harmony default export */ var greenflame1 = ({"src":"/_next/static/media/greenflame1.d36dfaa7.jpg","height":395,"width":424,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBRESEzH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABURAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIRAxEAPwCUl3aClnD/ABni17pi5vLwSOdBH0YQMRESKKDf/9k="});
;// CONCATENATED MODULE: ./src/assets/images/SHIVSWAY1.jpg
/* harmony default export */ var SHIVSWAY1 = ({"src":"/_next/static/media/SHIVSWAY1.ef88419f.jpg","height":395,"width":424,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABBAIDAQAAAAAAAAAAAAADAAEEEQITBRIhUf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhQf/aAAwDAQACEQMRAD8AmxTeTjH0ClkxaUbSxLtu+T2/n28rtERHYhtzh//Z"});
;// CONCATENATED MODULE: ./src/assets/images/SHIVSWAY2.jpg
/* harmony default export */ var SHIVSWAY2 = ({"src":"/_next/static/media/SHIVSWAY2.9d3a3671.jpg","height":395,"width":424,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDBAUREiExQf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIRAxEAPwC/dz1+vGZXY+KSwxwIY3Q2OhzJJ918REQpKpn/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/arow-ri.png
/* harmony default export */ var arow_ri = ({"src":"/_next/static/media/arow-ri.0d32b20a.png","height":37,"width":29,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAG1BMVEX////Wuors4Mvx59f38ej8+fXGoF3eyaS2iDlgnA3XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVQImWNggAFWZgjNyMTAwMDOyMjBxMDAzMTIxgKSYwSRDKyscNUABvMAQ8MjHNMAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/styles/csr.module.scss
var csr_module = __webpack_require__(84582);
var csr_module_default = /*#__PURE__*/__webpack_require__.n(csr_module);
;// CONCATENATED MODULE: ./src/pages/csr.tsx




swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);





















var Csr = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (csr_module_default()).csr_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: CSR_Banner_min1,
                    alt: "P. C. Sen Charitable Trust - Senco Gold and Diamonds",
                    width: 2313,
                    height: 923
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (csr_module_default()).health_services,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((csr_module_default()).health_services_image, " ", "pe-md-3"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                        className: "swiper-navigation",
                                        navigation: true,
                                        spaceBetween: 0,
                                        slidesPerView: 1,
                                        centeredSlides: true,
                                        autoplay: {
                                            delay: 9000,
                                            disableOnInteraction: false
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_1,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_2,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_3,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_4,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_5,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_6,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: health_7,
                                                    alt: "image",
                                                    width: 570,
                                                    height: 400
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (csr_module_default()).head_sec_csr,
                                        children: "Health Service wing:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (csr_module_default()).left_border,
                                        children: "Late Shankar Sen was Managing Director of Senco Gold & Diamonds Ltd and Vice Chairman of All India Gem and Jewellery Council. He was a generous and visionary personality who departed for heavenly abode in 2020. Late Sen envisioned through his holistic philosophy two prime necessities for the society – (a) healthy life style and (b) job oriented Skill Development support to rural population of South 24 Parganas."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "P C Sen Charitable Trust for the purpose, purchased huge land to build a health facility inclusive of a general hospital and a nursing academy. In addition he had two more plans – (a) to set-up an outstanding Paramedical Institute to provide technical academic support to the youths to be self-assured and (b) a home for old aged persons."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "His sole aim was to broaden the whole community where all people can easily reach to health and education to be healthy and youths to become self-dependent."
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (csr_module_default()).health_services,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-7",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (csr_module_default()).head_sec_csr,
                                            children: "Educational wing:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (csr_module_default()).left_border,
                                            children: "Shaankar Sen Institute For Vocational Studies For Women & Youth (Shivsway) ( SHIVSWAY) is laid on the foundation of philanthropic principal of Former Chairman& Managing Director of Senco Gold & Diamonds , Mr. Shaankar Sen. SHIVSWAY since its inception is pledged to build an inclusive eco-system of vocational studies that could transform the lives of thousand of youth & women by harnessing their potential for a rewarding career in emerging Retail and other industries."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Being guided by the insight & Vision of , Late Shaankar Sen and accelerated by the vigour & enthusiasm of our present MD & CEO , Mr. Shuvankar Sen, SHIVSWSY relentlessly work towards fulfilling our collective commitment towards the society at large by creating sustainable livelihood opportunities for all through Skill development and capacity building exercise. The path breaking initiatives aided & supported by Senco Group in the genre of Corporate Social Responsibility is propelled by the liberating thoughts to create an inclusive society where everyone will have seamless access to upskilling & reskilling opportunities and therefore will be provided with a level playing field to join skilled workforce, grow, prosper and can eventually forge a blissful life and career for themselves.Closely knitted to the cause of Social welfare by making everyone capable of living a life of dignity on the merit of their own skills and abilities."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We have also entered into a collaboration with Technical Education Dept. Of Govt Of West-Bengal and has emerged as an Associate Training partner with Paschim Banga Society For Skill Development (PBSSD) in their Utkarsh Bangla Project."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Presently we are pursuing two different training program under Gems & Jewellery Sector Skill Council at our Baguiati Centre. The details of the training are as follow."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((csr_module_default()).health_services_image, " ", "pe-md-3"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                            className: "swiper-navigation",
                                            navigation: true,
                                            spaceBetween: 0,
                                            slidesPerView: 1,
                                            centeredSlides: true,
                                            autoplay: {
                                                delay: 9000,
                                                disableOnInteraction: false
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: edu_1,
                                                        width: 570,
                                                        height: 750,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: edu_2,
                                                        width: 570,
                                                        height: 750,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: edu_3,
                                                        width: 570,
                                                        height: 750,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: edu_4,
                                                        width: 570,
                                                        height: 750,
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (csr_module_default()).cad_design,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (csr_module_default()).bg_white_trans,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (csr_module_default()).head_dark,
                                    children: "Jewellery Retail Sales Training"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: (csr_module_default()).text_red,
                                        children: "Training Outcome:"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Get students groomed & coached on the skill-set requirements recommended for Counter Sales Executive or Retail Sales Associate profile. Also implant the elements of confidence building , Corporate etiquette & personality development in them so as to help them emerge as someone who is capable of handing customer queries effectively, build a sustainable relationship with customers and can eventually ensure a favorable shopping experience for all who walk-into a Retail store."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: (csr_module_default()).text_red,
                                        children: "Training Pre-requisite:"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Students require a cheerful disposition equipped with a pleasing personality & an inherent ability to engage, influence & persuade others always stand suitable for the training. Those who are performance driven & have the confidence & perseverance to achieve organizational goals consistently will also have an edge over others in this genre of training."
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (csr_module_default()).jewellery_retail,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((csr_module_default()).header_center, " ", "mb-4"),
                                children: "CSR Education Projects"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((csr_module_default()).jewellery_retail_card, " ", "bg-white"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (csr_module_default()).jewellery_retail_images,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: kishalya1,
                                                                width: 424,
                                                                height: 395,
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((csr_module_default()).card_body_text, " ", "p-3", " ", "p-md-0"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (csr_module_default()).jewellery_sec,
                                                                        children: "KISHALAYA"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: (csr_module_default()).p_text,
                                                                        children: "Our humble support to underprivileged students in pursuing their basic education, either by extending one time or monthly financial support, or by donating educational kits and support system."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "kishalaya",
                                                                className: (csr_module_default()).arrow_more,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: arow_ri,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (csr_module_default()).jewellery_retail_image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: kishalya3,
                                                width: 424,
                                                height: 395,
                                                alt: ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((csr_module_default()).jewellery_retail_images_text, " ", "p-3"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (csr_module_default()).jewellery_sec,
                                                    children: "SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR CREATING LESS POLUTING RURAL KITCHEN"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "greenflame",
                                                    className: (csr_module_default()).arrow_more,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: arow_ri,
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((csr_module_default()).jewellery_retail_card, " ", "bg-white"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (csr_module_default()).jewellery_retail_images,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: greenflame1,
                                                                width: 424,
                                                                height: 395,
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((csr_module_default()).card_body_text, " ", "p-3", " ", "p-md-0"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (csr_module_default()).jewellery_sec,
                                                                    children: "GREEN FLAME"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (csr_module_default()).p_text,
                                                                    children: "The concept of Eco-Friendly Domestic or Community Chula has been designed by one of our beneficiary NGO, Alinan Ramakrishna Vivekananda Yuva Sangha, which has overall thermal efficiency of 23.08% and overall power rating of 1.33KW, and has been certified by School of Energy Studies, Jadavpur University. We have already installed 350 Improved Domestic Chullah at villages in districts of West Bengal, there by helping our Rural underprivileged women to have less polluting kitchen.."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((csr_module_default()).jewellery_retail_card, " ", "bg-white"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (csr_module_default()).jewellery_retail_images,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: SHIVSWAY1,
                                                                width: 424,
                                                                height: 395,
                                                                alt: ""
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((csr_module_default()).card_body_text, " ", "p-3", " ", "p-md-0"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (csr_module_default()).jewellery_sec,
                                                                        children: "SHIVSWAY"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: (csr_module_default()).p_text,
                                                                        children: "Gainful employment is the only way to empowerment. The ShivSway Shaankar Sen Institute for Vocational Studies for Women & Youth was created with a vision to empower and inspire marginalised youth."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "shivsway",
                                                                className: (csr_module_default()).arrow_more,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: arow_ri,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (csr_module_default()).jewellery_retail_image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: SHIVSWAY2,
                                                width: 424,
                                                height: 395,
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (csr_module_default()).video_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        width: "100%",
                                        height: "280",
                                        src: "https://www.youtube.com/embed/sx-qYzDSVhc",
                                        title: "Project Green Flame | PC SEN CHARITABLE TRUST",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                        allowFullScreen: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        width: "100%",
                                        height: "280",
                                        src: "https://www.youtube.com/embed/XKrTvLpydkM",
                                        title: "Project Kishalaya | PC SEN CHARITABLE TRUST",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                        allowFullScreen: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        width: "100%",
                                        height: "280px",
                                        src: "https://www.youtube.com/embed/db8ZsxXm3GQ",
                                        title: "Prabhat Diagnostic | A Unit of P C Sen Charitable Trust | Supported by\xa0Senco\xa0Gold\xa0Limited",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                        allowFullScreen: true
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var csr = (Csr);


/***/ }),

/***/ 84582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"csr_banner":"csr_csr_banner__2FHSL","csr_main":"csr_csr_main__InT4O","about_history":"csr_about_history__zYfzi","history_text":"csr_history_text__B1NeT","read_more":"csr_read_more__4dEzz","history_img":"csr_history_img__8jUis","visionaries":"csr_visionaries__nPyro","read_more2":"csr_read_more2___e32I","margin_50":"csr_margin_50__TH48_","about_video_section":"csr_about_video_section__4hW2g","font_bold":"csr_font_bold__pg0_R","read_more4":"csr_read_more4__fOHZg","para_width":"csr_para_width__7pBRi","about_video_new":"csr_about_video_new__wuQ16","about_video":"csr_about_video__WFfrM","play_icon1":"csr_play_icon1__5MppG","art_section":"csr_art_section___mMFH","mt_60":"csr_mt_60__hbsSm","art_text":"csr_art_text__iwjkA","read_more3":"csr_read_more3__KuAJW","last_banner":"csr_last_banner__C9iUh","video_container":"csr_video_container__lxbqb","last_csr_img":"csr_last_csr_img__VxLzU","health_services":"csr_health_services__7JCDR","health_services_image":"csr_health_services_image__TOYbY","head_sec_csr":"csr_head_sec_csr__XmFe5","left_border":"csr_left_border__5l115","cad_design":"csr_cad_design__mDIfJ","bg_white_trans":"csr_bg_white_trans__KKvRG","head_dark":"csr_head_dark__B99Ht","text_red":"csr_text_red__PoikD","header_center":"csr_header_center__S9wex","jewellery_retail_card":"csr_jewellery_retail_card__kzHKG","arrow_more":"csr_arrow_more__Vwz_O","bg-white":"csr_bg-white__MPQTT","card_body_text":"csr_card_body_text__cnNAV","jewellery_sec":"csr_jewellery_sec__TtJSv","p_text":"csr_p_text__s2db3","jewellery_retail_images":"csr_jewellery_retail_images__tFqvb","jewellery_retail_images_text":"csr_jewellery_retail_images_text__1JWcJ","jewellery_retail_image":"csr_jewellery_retail_image__QZEIs","jewellery_retail":"csr_jewellery_retail__zMSRJ"};

/***/ }),

/***/ 5607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(16518);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 27977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 55111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Marquee */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Animation = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, offset = _a.offset, id = _a.id;
    return (jsx("style", { children: "\n        @keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @-webkit-keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @media (prefers-reduced-motion) {\n            animation: none;\n            -webkit-animation: none;\n        }\n      " }, void 0));
};

var marqueeCounter = 0;
var Marquee = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, align = _a.align, background = _a.background, duration = _a.duration, height = _a.height, pauseOnHover = _a.pauseOnHover, width = _a.width, className = _a.className, children = _a.children;
    var _b = useState("running"), animate = _b[0], setAnimate = _b[1];
    var _c = useState(0), id = _c[0], setId = _c[1];
    useEffect(function () {
        setId(marqueeCounter);
        marqueeCounter++;
    }, []);
    var offsetValues = [-1, 0, 1];
    return (jsx("div", __assign({ className: className, onMouseEnter: function () { return pauseOnHover && setAnimate("paused"); }, onMouseLeave: function () { return pauseOnHover && setAnimate("running"); }, style: {
            display: "flex",
            overflow: "hidden",
            alignItems: "center",
            position: "relative",
            backgroundColor: background !== null && background !== void 0 ? background : "transparent",
            height: height !== null && height !== void 0 ? height : "5rem",
            width: width !== null && width !== void 0 ? width : "100%",
        } }, { children: offsetValues.map(function (offset) { return (jsxs("span", __assign({ style: {
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                position: "absolute",
                animation: "m" + id + "slide" + offset + " " + (duration !== null && duration !== void 0 ? duration : 5000) + "ms linear infinite",
                animationPlayState: animate !== null && animate !== void 0 ? animate : "running",
                minWidth: "100%",
            } }, { children: [jsx(Animation, { reverse: reverse, offset: offset, axis: axis, id: id }, void 0),
                jsx("div", __assign({ style: {
                        width: "100%",
                        height: "100%",
                        whiteSpace: "nowrap",
                        display: "flex",
                        overflow: "hidden",
                        justifyContent: "space-around",
                        flexDirection: axis === "X"
                            ? reverse
                                ? "row-reverse"
                                : "row"
                            : axis === "Y"
                                ? reverse
                                    ? "column-reverse"
                                    : "column"
                                : "row",
                        alignItems: align === "center" ? "center" : "flex-" + align,
                    } }, { children: children }), void 0)] }), offset)); }) }), void 0));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Marquee)));

//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,959,6067,3564,1825,9774,2888,179], function() { return __webpack_exec__(67809); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);